/* global axios */
import ApiClient from './ApiClient';

class DataAssistantReportsAPI extends ApiClient {
  constructor() {
    super('data_assistant/reports', { accountScoped: true });
  }

  moveReport(reportId, direction) {
    return axios.post(`${this.url}/${reportId}/move`, { direction });
  }

  addItem(reportId, itemData) {
    return axios.post(`${this.url}/${reportId}/items`, itemData);
  }

  updateItem(reportId, itemId, data) {
    return axios.patch(`${this.url}/${reportId}/items/${itemId}`, data);
  }

  removeItem(reportId, itemId) {
    return axios.delete(`${this.url}/${reportId}/items/${itemId}`);
  }

  moveItem(reportId, itemId, direction) {
    return axios.post(`${this.url}/${reportId}/items/${itemId}/move`, {
      direction,
    });
  }

  runItem(reportId, itemId, forceRefresh = false) {
    return axios.post(`${this.url}/${reportId}/items/${itemId}/run`, {
      force_refresh: forceRefresh,
    });
  }

  downloadItemCsv(reportId, itemId) {
    return axios.post(
      `${this.url}/${reportId}/items/${itemId}/run.csv`,
      {},
      { responseType: 'blob' }
    );
  }
}

export default new DataAssistantReportsAPI();
